import { render, staticRenderFns } from "./FreightAddPage.vue?vue&type=template&id=61cec650&scoped=true&"
import script from "./FreightAddPage.vue?vue&type=script&lang=js&"
export * from "./FreightAddPage.vue?vue&type=script&lang=js&"
import style0 from "./FreightAddPage.vue?vue&type=style&index=0&id=61cec650&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cec650",
  null
  
)

export default component.exports